import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import IMeasurementSetting, { IExportOptions } from "../../models/settings/MeasurementSettings";
import { MeasurementSetting } from '../../models/settings/MeasurementSettings';
import IThresholdSettings from '../../models/settings/ThresholdSettings';
import { ThresholdSettings } from '../../models/settings/ThresholdSettings';
import ISampleSettings, { SampleSettings } from '../../models/settings/SampleSettings';
import IBackupRestoreSetting, { BackupRestoreSetting } from '../../models/settings/BackupRestoreSettings';
import i18next from "i18next";

class SettingsActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getGeneral(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/general", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_GENERAL,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getLogoSetting(): Promise<void> {
        try {
            const request = new ApiRequest("/Settings/General/logo", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_LOGO,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getGraphSetting(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GraphSetting", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = result.data;
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_GRAPH_SETTINGS,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getThresholdReport(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/thresholdlimits/1/50/CreatedOn/Desc/%20", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertThresholdGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_THRESHOLD,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getSampleFields(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/samplefields/1/50/CreatedOn/Desc/%20", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertSampleFieldsGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_SAMPLE,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }


    async getSampleFieldsShow(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/Showsamplefields/1/50/CreatedOn/Desc/%20", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertSampleFieldsGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_SAMPLE,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getBackupRestoreConfig(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/BackupDbConfig", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertBackupRestoreGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_BACKUP_RESTORE,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getBackupXMLRestoreConfig(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/BackupXMLConfig", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            const payload = this.convertBackupRestoreGetData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_BACKUP_RESTORE_XML,
                payload: { data: payload },
            });
        } catch (error) {
            throw error;
        }
    }

    async getNewtorkPathConfig(queryString: any): Promise<any> {
        try {
            const request = new ApiRequest("/settings/GetNewtorkPathConfig?backuptype=" + queryString, "", null, i18next.t("Tested backup folder connection."));
            const result = await this.api.get(request);

            const payload = queryString !== "BackupRestore" ? this.prepareNetworkPathConfigData(result.data) : this.convertBackupRestoreGetData(result.data);
            return payload;
        } catch (error) {
            throw error;
        }
    }

    async networkPathConfig(data: any, requestId: string, backuptype: string): Promise<void> {
        try {
            const payload: any = this.prepareBackupSettingsPayload(data);
            const request = new ApiRequest("/settings/UpdateNetworkPathConfig?backuptype=" + backuptype, requestId, payload, i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.NETWORK_PATH_CONFIG,
                payload: {
                    message: result?.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async networkPathConfigFileExport(data: any, requestId: string, backuptype: string): Promise<void> {
        try {
            const payload: any = this.preparePutNetworkPathConfigData(data);
            const request = new ApiRequest("/settings/UpdateFileExportType", requestId, payload, i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.NETWORK_PATH_CONFIG,
                payload: {
                    message: result?.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async testBackupFolderConnection(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareBackupSettingsPayload(data);
            const request = new ApiRequest("/settings/CheckFolderConnection", requestId, payload, i18next.t("Tested Backup folder connection."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TEST_BACKUP_FOLDER_CONNECTION,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async testBackupXMLFolderConnection(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareFileExportSettingsPayload(data);
            const request = new ApiRequest("/settings/CheckFolderConnectionForExportFileSetting", requestId, payload, i18next.t("Tested Export XML folder connection."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TEST_BACKUP_SAMPLE_FOLDER_CONNECTION,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async testBackupXMLFolderConnections(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareFileExportSettingsPayload(data);
            const request = new ApiRequest("/settings/CheckFolderConnectionForExportFileSetting", requestId, payload, i18next.t("Tested Export XML folder connection."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TEST_BACKUP_FOLDER_CONNECTION_XML,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async testBackupXLSFolderConnections(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareFileExportSettingsPayload(data);
            const request = new ApiRequest("/settings/CheckFolderConnectionForExportFileSetting", requestId, payload, i18next.t("Tested Export XLS folder connection."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TEST_BACKUP_FOLDER_CONNECTION_XLS,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async testBackupAL1FolderConnections(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareFileExportSettingsPayload(data);
            const request = new ApiRequest("/settings/CheckFolderConnectionForExportFileSetting", requestId, payload, i18next.t("Tested Export AL1 folder connection."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TEST_BACKUP_FOLDER_CONNECTION_AL1,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }


    async submit(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);
            const request = new ApiRequest("/settings/general", requestId, payload, i18next.t("Settings Updated."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GENERAL_SETTING_SUBMIT,
                payload: {
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async submitThreshold(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareThresholdPayload(data);
            const request = new ApiRequest("/settings/ThresholdLimits", requestId, payload, i18next.t("Settings Updated."));
            await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.THRESHOLD_SETTING_SUBMIT,
                payload: {
                    message: i18next.t("Settings Updated.")
                }
            });
        } catch (error) {
            throw error;
        }
    }


    async submitSampleField(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareSamplePayload(data);
            const request = new ApiRequest("/settings/SampleFields", requestId, payload, i18next.t("Settings Updated."));
            await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_SETTING_SUBMIT,
                payload: {
                    message: "Settings Updated."
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async submitBackupSettings(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareBackupSettingsPayload(data);
            const request = new ApiRequest("/settings/BackupDbConfig", requestId, payload, i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_SETTING_SUBMIT,
                payload: {
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async submitBackupXMLSettings(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareBackupSettingsPayload(data);
            const request = new ApiRequest("/settings/BackupXMLConfig", requestId, payload, i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_SETTING_SUBMIT_XML,
                payload: {
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async submitBackupAL1Settings(data: any, requestId: string): Promise<void> {
        try {
            const payload: any = this.prepareBackupSettingsPayload(data);
            const request = new ApiRequest("/settings/BackupAL1Config", requestId, payload, i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_SETTING_SUBMIT_AL1,
                payload: {
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async getDownloadSampleXMLOnCreateSample(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GetDownloadSampleXMLOnCreateSample", "", null, i18next.t("Backup Settings Updated."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_DOWNLOAD_SAMPLE_XML_ON_CREATE_SAMPLE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async getDownloadSampleXMLOnApprove(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GetDownloadSampleMeasurementXMLOnSampleApprove", "", null, i18next.t("Backup Settings Updated."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_DOWNLOAD_SAMPLE_XML_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async getDownloadSampleXLSOnApprove(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GetDownloadSampleMeasurementXLSOnSampleApprove", "", null, i18next.t("Backup Settings Updated."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_DOWNLOAD_SAMPLE_XLS_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async getDownloadSampleAL1OnApprove(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GetDownloadSampleMeasurementAL1OnSampleApprove", "", null, i18next.t("Backup Settings Updated."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.GET_DOWNLOAD_SAMPLE_AL1_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async updateDownloadSampleXMLOnCreateSample(value: any, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/settings/UpdateDownloadSampleXMLOnCreateSample", requestId, value ? "true" : "false", i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.UPDATE_DOWNLOAD_SAMPLE_XML_ON_CREATE_SAMPLE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            console.log("On Create", error);
            throw error;
        }
    }

    async updateDownloadSampleXMLOnApprove(value: any, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/settings/UpdateDownloadSampleMeasurementXMLOnSampleApprove", requestId, value ? "true" : "false", i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.UPDATE_DOWNLOAD_SAMPLE_XML_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            console.log("On Approve", error);
            throw error;
        }
    }

    async updateDownloadSampleXLSOnApprove(value: any, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/settings/UpdateDownloadSampleMeasurementXLSOnSampleApprove", requestId, value ? "true" : "false", i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.UPDATE_DOWNLOAD_SAMPLE_XLS_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            console.log("On Approve", error);
            throw error;
        }
    }

    async updateDownloadSampleAL1OnApprove(value: any, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/settings/UpdateDownloadSampleMeasurementAL1OnSampleApprove", requestId, value ? "true" : "false", i18next.t("Backup Settings Updated."));
            const result = await this.api.put(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.UPDATE_DOWNLOAD_SAMPLE_AL1_ON_APPROVE,
                payload: {
                    message: result
                }
            });

        } catch (error) {
            console.log("On Approve", error);
            throw error;
        }
    }


    //GetExportOptions
    async getExportOptions(requestData: string[]): Promise<IExportOptions[]> {
        try {
            const request = new ApiRequest('/Settings/GetExportOptions', '', requestData, i18next.t("Export Options"));
            const result = await this.api.post(request);
            return result.data;
        } catch (error) {
            throw error.message;
        }
    }


    private convertGetData(data: IMeasurementSetting): any {
        return new MeasurementSetting(data.id, data.isMeanTendency,
            data.isStdDeviation, data.header,
            data.subHeader, data.footer, data.logo, data.fileNamePrefix,
            data.isSaveFormatPdf, data.reportSaveLocation, data.isAutoGenerateReport,
            data.isAutoGenerateRealReport, data.isAutoGenerateValueReport, data.isAutoGeneratePositionReport,
            data.isAutoGenerateGraphReport, data.selectedGraphType)
    }
    private convertThresholdGetData(data: any): any {
        const payload: IThresholdSettings[] = []
        data?.contents.map((values: IThresholdSettings) => {
            payload.push(new ThresholdSettings(values.id, values.key, values.name, values.colorCode))
        })
        return payload
    }

    private convertSampleFieldsGetData(data: any): any {
        const payload: ISampleSettings[] = []
        data?.contents.map((values: ISampleSettings) => {
            payload.push(new SampleSettings(values.id, values.key, values.name, values.show))
        })
        return payload
    }

    private convertBackupRestoreGetData(data: any): any {
        let payload: any = [];
        let credentials = null;
        if (data.credentials === null) {
            credentials = [{
                domain: "",
                userName: "",
                password: ""
            }]
        }

        payload = [{
            credentials: data.credentials === null ? credentials : data.credentials,
            drive: data.drive,
            isNetworkShared: data.isNetworkShared,
            location: data.location,
            isTestLoading: data.isTestLoading,
            isActive: data.isActive
        }]
        return payload
    }

    private prepareNetworkPathConfigData(data: IBackupRestoreSetting): any {
        return {
            id: data.id,
            exportType: data.exportType,
            fileSaveType: data.fileSaveType,
            domain: data.domain,
            username: data.username,
            password: data.password,
            drive: data.drive,
            ipAddress: data.ipAddress,
            port: data.port,
            location: data.location,
            isTestLoading: data.isTestLoading,
            isActive: data.isActive,
            passPhrase: data.passPhrase,
            autoGenerateType: data.autoGenerateType,
        }
    }

    private preparePutNetworkPathConfigData(data: IBackupRestoreSetting[]): any {
        let tempData: any = []
        data.map((i: any) => {
            let a = {
                id: i.id,
                exportType: i.exportType,
                fileSaveType: i.fileSaveType,
                domain: i.domain,
                username: i.username,
                password: i.password,
                drive: i.drive,
                ipAddress: i.ipAddress,
                port: i.port,
                location: i.location,
                isActive: i.isActive,
                passPhrase: i.passPhrase,
                autoGenerateType: i.autoGenerateType,
            }
            tempData.push(a)
        })
        return {
            updateFileExportSettings: tempData
        }
    }

    private preparePostPayload(data: any): any {
        return {
            id: data.id,
            isMeanTendency: data.meanTendency[0] === 0 ? true : false,
            isStdDeviation: data.stdDeviation[0] === 0 ? true : false,
            header: data.header,
            subHeader: data.subHeader,
            footer: data.footer,
            fileNamePrefix: data.fileNamePrefix,
            isSaveFormatPdf: data.saveFormatPdf === 'PDF' ? true : false,
            reportSaveLocation: data.reportSaveLocation,
            isAutoGenerateReport: data.isAutoGenerateReport,
            isAutoGenerateRealReport: data.isAutoGenerateRealReport,
            isAutoGenerateValueReport: data.isAutoGenerateValueReport,
            isAutoGeneratePositionReport: data.isAutoGeneratePositionReport,
            isAutoGenerateGraphReport: data.isAutoGenerateGraphReport,
            selectedGraphType: data.selectedGraphType,
            logo: data.logo === null ? "" : data.logo,
            generateXml: data.generateXML
        }
    }

    private prepareBackupSettingsPayload(data: any): any {
        return {
            isNetworkShared: data[0].isNetworkShared,
            credentials: {
                domain: data[0].isNetworkShared ? data[0].credentials.domain : "",
                userName: data[0].isNetworkShared ? data[0].credentials.userName : "",
                password: data[0].isNetworkShared ? data[0].credentials.password : ""
            },
            drive: data[0].isNetworkShared ? data[0].drive : "",
            location: data[0].location,
            isTestLoading: data[0].isTestLoading,
            isActive: data[0].isActive
        }
    }

    private prepareFileExportSettingsPayload(data: any): any {
        return {
            id: data.id,
            exportType: data.exportType,
            fileSaveType: data.fileSaveType,
            domain: data.domain,
            username: data.username,
            password: data.password,
            drive: data.drive,
            ipAddress: data.ipAddress,
            port: data.port,
            location: data.location,
            isTestLoading: data.isTestLoading,
            isActive: data.isActive,
            passPhrase: data.passPhrase,
        }
    }

    private prepareThresholdPayload(data: IThresholdSettings[]): any {
        return { updateThresholdLimits: data }
    }

    private prepareSamplePayload(data: ISampleSettings[]): any {
        return { updateSampleFields: data }
    }

    async getAutoDeleteSettings(): Promise<void> {
        try {
            const request = new ApiRequest("/settings/GetAutoDelete", "", null, i18next.t("Unable to fetch Settings Data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_GET_AUTO_DELETE,
                payload: { data: result },
            });
        } catch (error) {
            throw error;
        }
    }

    async postAutoDeleteSettings(data: any, requestId: string): Promise<void> {
        try {
            const payload = this.prepareAutoDeletePayload(data);
            const request = new ApiRequest("/settings/AddAutoDelete", requestId, payload, i18next.t("Unable to update data."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_POST_AUTO_DELETE,
                payload: {
                    data: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async putAutoDeleteSettings(data: any, requestId: string): Promise<void> {
        try {
            const payload = this.prepareAutoDeletePayload(data);
            const request = new ApiRequest("/settings/UpdateAutoDeleteSettings", requestId, payload, i18next.t("Unable to update data."));
            const result = await this.api.put(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SETTINGS_PUT_AUTO_DELETE,
                payload: {
                    message: result?.message
                }
            });
        } catch (error) {
            throw error;
        }
    }

    private prepareAutoDeletePayload(data: any) {
        const payload = {
            frequency: data.frequency,
            frequencyId: {
                id: data.frequencyId,
                name: data.selectedFrequencyType
            },
            autoDeleteTimingInHours: data.autoDeleteTimingInHours,
            autoDeleteTimingInMinutes: data.autoDeleteTimingInMinutes,
            autoDeleteInterval: data.autoDeleteInterval,
            autoDeleteIntervalId: {
                id: data.autoDeleteIntervalId,
                name: data.selectedAutoDeleteInterval
            },
            isAutoDeleteOn: data.isAutoDeleteOn
        };
        return payload;
    }


}

const settingsActions = new SettingsActions();
export default settingsActions;
